<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      width="300"
      color="primary"
      dark
      fixed
      temporary
      app
    >
      <v-list-item>
        <v-list-item-avatar>
          <v-img :src="this.photourl" height="100" width="100" contain></v-img>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title color="white">{{
            this.currentUser
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>
      <div v-if="isAdmin">
        <v-list>
          <v-list-item
            v-for="item in adminitems"
            :key="item.title"
            :to="item.link"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
      <div v-else>
        <v-list>
          <v-list-item
            v-for="item in guestitems"
            :key="item.title"
            :to="item.link"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
    </v-navigation-drawer>
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      dense
      color="primary"
      dark
    >
      <!-- <img
        height="30"
        width="30"
        src="data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64' aria-labelledby='title' aria-describedby='desc' role='img' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3EAirplane Mode%3C/title%3E%3Cdesc%3EA solid styled icon from Orion Icon Library.%3C/desc%3E%3Cpath data-name='layer1' d='M25.7 57.4L41.5 37h15a5 5 0 0 0 0-10h-15L25.7 6.6S24.6 5 23.5 5h-4.2a1.4 1.4 0 0 0-1.3.7c-.2.5.3 1.9.5 2.4L24.6 27H13.5L8 19.7a1.6 1.6 0 0 0-1.4-.7H3.5c-.4 0-1.3.1-.8 1.4S7.5 32 7.5 32 3.2 42.2 2.7 43.6s.5 1.4.8 1.4h3.1a1.6 1.6 0 0 0 1.4-.7l5.5-7.3h11.1l-6.1 18.9c-.2.5-.7 1.9-.5 2.4a1.3 1.3 0 0 0 1.3.7h4.2c1.1 0 2.2-1.6 2.2-1.6z' fill='%23ffffff'%3E%3C/path%3E%3C/svg%3E"
        alt="Airplane Mode"
      /> -->
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title style="width: 150px" class="ml-0 pl-4">
        <router-link class="hidden-xs-only" to="/">transformPNR</router-link>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn text @click="logout">
        <v-icon class="mr-2">mdi-power</v-icon>
        Logout
      </v-btn>
    </v-app-bar>
    <v-main>
      <v-container fill-height>
        <v-layout align-center justify-center>
          <slot />
        </v-layout>
      </v-container>
    </v-main>

    <AdminFooter />
  </div>
</template>

<script>
import AdminFooter from "@/components/AdminFooter";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";

export default {
  components: {
    AdminFooter,
  },

  data() {
    return {
      uid: "",
      isAdmin: false,
      currentUser: "",
      photourl: "",
      drawer: false,
      adminitems: [
        { title: "Airlines", icon: "mdi-airplane", link: "/airlines" },
        { title: "Airports", icon: "mdi-airplane-takeoff", link: "/airports" },
        { title: "Cabins", icon: "mdi-file-tree", link: "/cabins" },
        { title: "Fare Rules", icon: "mdi-file", link: "/farerules" },
        { title: "Decoder", icon: "mdi-wrench", link: "/decoder" },
        { title: "Profile", icon: "mdi-account", link: "/profile" },
        {
          title: "User Registration",
          icon: "mdi-account-plus",
          link: "/register",
        },
        {
          title: "Roles & Permissions",
          icon: "mdi-cog",
          link: "/users",
        },
      ],
      guestitems: [
        { title: "Fare Rules", icon: "mdi-file", link: "/farerules" },
        { title: "Decoder", icon: "mdi-wrench", link: "/decoder" },
        { title: "Profile", icon: "mdi-account", link: "/profile" },
      ],
    };
  },

  created() {
    firebase.auth().onAuthStateChanged((userAuth) => {
      if (userAuth) {
        this.currentUser = userAuth.displayName;
        this.photourl = userAuth.photoURL;
        firebase
          .auth()
          .currentUser.getIdTokenResult()
          .then((tokenResult) => {
            this.isAdmin = tokenResult.claims.admin;
          });
      }
    });
  },

  methods: {
    async logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace("/");
        });
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none !important;
  color: white !important;
}
.v-btn {
  font-size: 0.75em;
}
</style>
